/* Silhouette Rider — front-end interactions (preview) */
(function () {
  'use strict';

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sr-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Newsletter pop-up ---- */
  function initPopup() {
    var pop = document.getElementById('sr-pop');
    if (!pop) return;
    var KEY = 'sr_pop_seen';
    function open() { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); }
    function close() {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    }
    // In Shopify's theme editor, always show so the client/designer can preview it.
    var design = document.documentElement.classList.contains('shopify-design-mode');
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    // After the customer form posts, Shopify reloads the page with a success or
    // error state rendered inside the popup — reopen it so the visitor sees it.
    var posted = pop.querySelector('[data-sr-pop-success]');
    var errored = pop.querySelector('[data-sr-pop-error]');
    if (posted || errored) {
      window.setTimeout(open, 400);
      if (posted) { window.setTimeout(close, 4500); }
    } else if (design || !seen) {
      window.setTimeout(open, design ? 400 : 2500);
    }

    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.hasAttribute('data-sr-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var form = pop.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('.sr-pop__submit');
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      });
    }
    // expose for "open" triggers (e.g. footer link)
    document.querySelectorAll('[data-sr-pop-open]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }

  /* ---- Product: gallery + colour + size + bundle ---- */
  function initProduct() {
    document.querySelectorAll('[data-sr-product]').forEach(function (root) {
      /* crossfade: preload the incoming image so the fade-in never shows a blank frame */
      function swapMain(group, full, alt) {
        if (!group) return;
        var mainImg = group.querySelector('[data-sr-main] img');
        if (!mainImg || !full || mainImg.src === full) return;
        var pre = new Image();
        var applied = false;
        function apply() {
          if (applied) return;
          applied = true;
          mainImg.src = full;
          if (alt) mainImg.alt = alt;
          window.requestAnimationFrame(function () { mainImg.classList.remove('is-fading'); });
        }
        mainImg.classList.add('is-fading');
        pre.onload = function () { window.setTimeout(apply, 200); };
        pre.onerror = apply;
        pre.src = full;
        window.setTimeout(apply, 900); /* fail-safe: never stay faded out */
      }

      /* real-product variant data (present only when bound to a Shopify product) */
      var variants = [];
      var vEl = root.querySelector('[data-sr-variants]');
      if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) {} }
      var idEl = root.querySelector('[data-sr-variant-id]');
      var qtyEl = root.querySelector('[data-sr-qty]');
      var formEl = root.querySelector('[data-sr-form]');
      var priceEl = root.querySelector('[data-sr-price]');
      var atcEl = root.querySelector('[data-sr-atc]');
      var atcBase = atcEl ? atcEl.textContent.split('—')[0].trim() : 'Add to Cart';
      var pairsWrap = root.querySelector('[data-sr-pairs]');
      var preorderShipEl = root.querySelector('[data-sr-ship]');

      function pairEls() {
        return Array.prototype.slice.call(root.querySelectorAll('[data-sr-pair]'));
      }
      function activeBundle() {
        return root.querySelector('[data-sr-bundle].is-active') || root.querySelector('[data-sr-bundle]');
      }
      function isBundle() {
        var b = activeBundle();
        return !!b && b.getAttribute('data-sr-bundle') === 'pair';
      }
      function pairColor(pair) {
        var sw = pair.querySelector('[data-sr-swatch].is-active');
        return sw ? sw.getAttribute('data-color') : null;
      }
      function pairSize(pair) {
        var sz = pair.querySelector('[data-sr-size][aria-pressed="true"]');
        return sz ? sz.getAttribute('data-size') : null;
      }
      function pairShip(pair) {
        var sw = pair.querySelector('[data-sr-swatch].is-active');
        return sw ? sw.getAttribute('data-ship') : null;
      }
      function resolvePair(pair) {
        if (!variants.length || !pair) return null;
        var c = pairColor(pair), s = pairSize(pair);
        return variants.filter(function (v) { return v.color === c && v.size === s; })[0] || null;
      }

      /* compare "Month YYYY" strings so the bundle can show the later of two ship dates */
      var MONTHS = { january: 1, february: 2, march: 3, april: 4, may: 5, june: 6, july: 7, august: 8, september: 9, october: 10, november: 11, december: 12 };
      function dateRank(str) {
        if (!str) return -1;
        var m = str.toLowerCase().match(/([a-z]+)\s+(\d{4})/);
        if (!m || !MONTHS[m[1]]) return -1;
        return parseInt(m[2], 10) * 100 + MONTHS[m[1]];
      }

      function updateShipLines() {
        var pairs = pairEls();
        pairs.forEach(function (pair) {
          var el = pair.querySelector('[data-sr-pair-ship]');
          var ship = pairShip(pair);
          if (el && ship) el.textContent = 'Ships ' + ship;
        });
        if (!preorderShipEl) return;
        if (isBundle() && pairs.length > 1) {
          var d1 = pairShip(pairs[0]), d2 = pairShip(pairs[1]);
          var later = dateRank(d2) > dateRank(d1) ? d2 : d1;
          var differ = d1 && d2 && d1 !== d2;
          if (later) preorderShipEl.textContent = 'Pre-order — ships ' + later + (differ ? ' (both pairs ship together)' : '');
        } else {
          var d = pairShip(pairs[0]);
          if (d) preorderShipEl.textContent = 'Pre-order — ships ' + d;
        }
      }

      /* resolve selections to variant ids; sync price, pair visibility, button state */
      function resync() {
        var b = activeBundle();
        var price = b ? b.getAttribute('data-price') : null;
        if (priceEl && price) priceEl.textContent = '$' + price;

        var bundle = isBundle();
        var pairs = pairEls();
        if (pairs[1]) pairs[1].hidden = !bundle;
        if (pairsWrap) pairsWrap.classList.toggle('is-bundle', bundle);

        updateShipLines();

        if (!variants.length) {
          if (atcEl && price) atcEl.textContent = atcBase + ' — $' + price;
          return;
        }

        var v1 = resolvePair(pairs[0]);
        if (idEl) idEl.value = v1 ? v1.id : '';
        if (qtyEl) qtyEl.value = '1';

        if (!atcEl) return;
        if (!bundle) {
          if (v1) { atcEl.disabled = false; atcEl.textContent = atcBase + ' — $' + price; }
          else { atcEl.disabled = true; atcEl.textContent = 'Select size'; }
        } else {
          var v2 = resolvePair(pairs[1]);
          if (v1 && v2) { atcEl.disabled = false; atcEl.textContent = atcBase + ' — $' + price; }
          else { atcEl.disabled = true; atcEl.textContent = 'Select size for both pairs'; }
        }
      }

      /* thumbnails — scoped to their colour group */
      root.querySelectorAll('[data-sr-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var group = thumb.closest('.sr-pcolor');
          var img = thumb.querySelector('img');
          swapMain(group, thumb.getAttribute('data-full'), img ? img.alt : '');
          if (group) group.querySelectorAll('[data-sr-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });

      /* gallery prev/next — cycles the active colour's images, thumbs stay in sync
         because stepping goes through the thumbnail's own click handler */
      function stepGallery(group, dir) {
        if (!group) return;
        var thumbs = group.querySelectorAll('[data-sr-thumb]');
        if (thumbs.length < 2) return;
        var current = 0;
        thumbs.forEach(function (t, i) { if (t.getAttribute('aria-current') === 'true') current = i; });
        thumbs[(current + dir + thumbs.length) % thumbs.length].click();
      }

      root.querySelectorAll('[data-sr-gnav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          stepGallery(btn.closest('.sr-pcolor'), parseInt(btn.getAttribute('data-sr-gnav'), 10));
        });
      });

      /* hide arrows for single-image galleries */
      root.querySelectorAll('.sr-pcolor').forEach(function (g) {
        if (g.querySelectorAll('[data-sr-thumb]').length < 2) {
          g.querySelectorAll('[data-sr-gnav]').forEach(function (b) { b.hidden = true; });
        }
      });

      /* keyboard: left/right arrows page the active gallery */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
        stepGallery(root.querySelector('.sr-pcolor.is-active'), e.key === 'ArrowRight' ? 1 : -1);
      });

      /* touch: horizontal swipe on the main image */
      root.querySelectorAll('[data-sr-main]').forEach(function (main) {
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) {
          var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - x0, dy = t.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            stepGallery(main.closest('.sr-pcolor'), dx < 0 ? 1 : -1);
          }
        }, { passive: true });
      });

      /* colour swatches — active state is per-pair; the shared gallery follows any click */
      root.querySelectorAll('[data-sr-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var pair = sw.closest('[data-sr-pair]');
          var color = sw.getAttribute('data-color');
          if (pair) {
            pair.querySelectorAll('[data-sr-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            var nm = pair.querySelector('[data-sr-colorname]');
            if (nm) nm.textContent = color;
          }
          root.querySelectorAll('.sr-pcolor').forEach(function (g) {
            g.classList.toggle('is-active', g.getAttribute('data-color') === color);
          });
          resync();
        });
      });

      /* sizes — scoped to their own pair */
      root.querySelectorAll('[data-sr-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pair = btn.closest('[data-sr-pair]');
          (pair || root).querySelectorAll('[data-sr-size]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          resync();
        });
      });

      /* bundle / quantity — single vs 2-pack */
      root.querySelectorAll('[data-sr-bundle]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          root.querySelectorAll('[data-sr-bundle]').forEach(function (o) {
            o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-active'); opt.setAttribute('aria-pressed', 'true');
          resync();
        });
      });

      /* submit: single unit posts normally; the 2-pack adds two line items via AJAX
         so each pair can be a different colour/size */
      if (formEl) {
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        formEl.addEventListener('submit', function (e) {
          if (!variants.length) return;
          var pairs = pairEls();
          if (!isBundle()) {
            if (!idEl || !idEl.value) { e.preventDefault(); resync(); }
            return; /* let the normal form POST add the single unit */
          }
          e.preventDefault();
          var a = resolvePair(pairs[0]), b = resolvePair(pairs[1]);
          if (!a || !b) { resync(); return; }
          if (atcEl) { atcEl.disabled = true; atcEl.textContent = 'Adding…'; }
          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [ { id: a.id, quantity: 1 }, { id: b.id, quantity: 1 } ] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = rootUrl + 'cart';
          }).catch(function () {
            if (atcEl) { atcEl.disabled = false; atcEl.textContent = 'Could not add — try again'; }
          });
        });
      }

      resync();
    });
  }

  /* ---- Mobile menu drawer ---- */
  function initMenu() {
    var toggle = document.querySelector('[data-sr-menu-toggle]');
    var drawer = document.querySelector('[data-sr-drawer]');
    if (!toggle || !drawer) return;
    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
    }
    toggle.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---- Page-to-page fade (fallback for browsers without cross-document
     view transitions; theme.liquid sets html.sr-page-fade pre-paint) ---- */
  function initPageFade() {
    var d = document.documentElement;
    if (!d.classList.contains('sr-page-fade')) return;
    if (d.classList.contains('shopify-design-mode')) { d.classList.remove('sr-page-fade'); return; }

    /* bfcache restore would otherwise show the page stuck faded-out */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) d.classList.remove('sr-page-out');
    });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return;

      e.preventDefault();
      d.classList.add('sr-page-out');
      window.setTimeout(function () { window.location.href = a.href; }, 350);
    });
  }

  function init() { initReveal(); initPopup(); initProduct(); initMenu(); initPageFade(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
